<template>
  <div
    :class="[
      { 'h-8 w-8': small },
      { 'h-7 w-7': xsmall },
      { 'border rounded border-white': border },
      { 'flex items-center relative ml-[-10px]': stacked },
      'h-12 w-12',
    ]"
    class="flex flex-shrink-0 items-center justify-center rounded-full overflow-hidden"
    :style="`background-color: ${bgColor}`"
  >
    <span
      class="text-white font-medium tracking-wider"
      :class="{ 'text-xs': small || xsmall }"
      v-if="error"
      >{{ letter }}</span
    >
    <img
      class="w-full h-full rounded-full object-cover"
      v-else
      :src="url"
      @load="loaded"
      @error="errorLoading"
    />
  </div>
</template>

<script>
export default {
  name: "Avatar",
  emits: [],
  props: {
    small: {
      required: false,
      default: false,
      type: Boolean,
    },
    xsmall: {
      required: false,
      default: false,
      type: Boolean,
    },
    user: {
      required: true,
    },
    project: {
      required: false,
    },
    useImage: {
      required: false,
      type: Boolean,
      default: true,
    },
    border: {
      required: false,
      type: Boolean,
      default: false,
    },
    stacked: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  computed: {
    letter() {
      const name = this.user.name.split(" ")
      if (name.length > 0) {
        const letter = name.slice(0, 2).map((letter) => {
          if (!letter) {
            return ""
          }
          return letter[0].toUpperCase()
        })

        return letter.join("").toUpperCase()
      }

      return ""
    },

    bgColor() {
      return this.stringToHslColor(this.user.name, 40, 50)
    },
  },

  data() {
    return {
      url: "",
      letters: "",
      token: window.FinancialCents.auth,
      error: !this.useImage,
    }
  },

  beforeMount() {
    if (this.user.avatar) {
      this.url = `/api/client-portal/avatar/${this.user.id}`
    }
  },

  methods: {
    loaded(e) {
      this.error = false
    },

    errorLoading(e) {
      this.error = true
    },

    stringToHslColor(str, s, l) {
      let hash = 0
      for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash)
      }

      let h = Math.abs(hash) % 360
      return "hsl(" + h + ", " + s + "%, " + l + "%)"
    },
  },
}
</script>

<style scoped></style>
